import { connect } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import config from "../../utils/config";
import { separateNum } from "../../utils";
import { cartsChanged } from "../../store/action/cart";
import CartService from "../../services/cart/Cart";
import Card from "../../components/card";
import Quantity from "../../components/quantity";
import {
  Div,
  Row,
  Col,
  CardLink,
  CardContainerFood,
  ContainerFood,
  ContainerQuantity,
  FoodImg,
  FoodName,
  FoodPrice,
  FoodPriceDis,
  ItemTrash,
  TrashIcon,
  FoodOfferPercent,
} from "./style";

const Item = (props) => {
  const { data, theme, index, carts, cartsChanged } = props;

  const plusQuantity = () => {
    return carts?.items[data]?.count + 1;
  };

  const addToCart = (quantity, e) => {
    if (e) {
      e.preventDefault();
    }

    CartService.changedItems(carts, carts?.items[data], quantity, cartsChanged);
  };

  const deleteCartItem = () => {
    CartService.remove(data, carts, cartsChanged);
  };

  return (
    <>
      <Col className="col-12 mb-2 text-right">
        <CardContainerFood sel={index % 2}>
          <Card className="py-2">
            <CardLink href="/" onClick={(e) => addToCart(plusQuantity(), e)}>
              <Row className="row no-gutters">
                <Col className="col-4 text-center">
                  <FoodImg
                    src={carts?.items[data]?.images[0]?.full_url}
                    height="100"
                  />
                </Col>
                <Col className="col-8">
                  <ContainerFood className="mr-2">
                    <FoodName theme={theme} className="mt-2">
                      {carts?.items[data]?.name}
                    </FoodName>
                    {carts?.items[data]?.has_offer ? (
                      <>
                        <Div className="mt-2">
                          <Div className="d-inline-block">
                            <FoodOfferPercent theme={theme}>
                              {carts?.items[data]?.offer_percentage}%
                            </FoodOfferPercent>
                          </Div>
                          <Div className="d-inline-block vertical-align-middle mr-2 pb-1">
                            <FoodPriceDis theme={theme} className="mt-2">
                              {separateNum(carts?.items[data]?.price)}
                            </FoodPriceDis>
                            <FoodPrice className="line-height-10" theme={theme}>
                              {`${separateNum(carts?.items[data]?.payable)} ${
                                config.currency
                              }`}
                            </FoodPrice>
                          </Div>
                        </Div>
                      </>
                    ) : (
                      <FoodPrice theme={theme} className="mt-2">
                        {`${separateNum(carts?.items[data]?.price)} ${
                          config.currency
                        }`}
                      </FoodPrice>
                    )}
                  </ContainerFood>
                </Col>
              </Row>
            </CardLink>
            <ContainerQuantity>
              <Quantity
                quantity={carts?.items[data]?.count}
                setQuantity={addToCart}
              />
            </ContainerQuantity>
            <ItemTrash>
              <IconButton color="inherit" onClick={deleteCartItem}>
                <TrashIcon
                  className="far fa-trash f-14"
                  theme={theme}
                ></TrashIcon>
              </IconButton>
            </ItemTrash>
          </Card>
        </CardContainerFood>
      </Col>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
    carts: state.carts?.carts,
  };
};

export default connect(mapStateToProps, { cartsChanged })(Item);
